<template>
    <i class="mdi mdi-spin mdi-autorenew mdi-48px text-primary" v-if="shouldShow && !withCard"></i>
    <div class="card shadow-sm" v-else-if="shouldShow && withCard">
        <div class="card-body">
            <i class="mdi mdi-spin mdi-autorenew mdi-48px text-primary"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "StaticLoadingIndicatorIcon",
    props: {
        loading: {
            type: Boolean,
            default: null
        },
        withCard: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        shouldShow() {
            if(this.loading !== null) {
                return this.loading;
            }
            return this.$store.getters.isExecutingRequest;
        }
    }
}
</script>

<style scoped>

</style>
